import { useState } from "react";
import { motion } from "framer-motion";
import { useLanding } from "@/context/LandingContext";
import { InteractiveSection, MotionBg } from "./MotionBg";
import { Reveal } from "./Reveal";

const NO_INITIAL = { scale: 0.8 };
const NO_ANIMATE = { scale: 1 };
const COPY_INITIAL = { opacity: 0.4, y: 8 };
const COPY_ANIMATE = { opacity: 1, y: 0 };
const COPY_TRANSITION = { duration: 0.36 };
const DETAIL_INITIAL = { opacity: 0.4 };
const DETAIL_ANIMATE = { opacity: 1 };

export function Journey() {
  const { t } = useLanding();
  const [active, setActive] = useState(0);
  const step = t.journey.steps[active];

  return (
    <InteractiveSection className="section journey-section" data-testid="journey-section">
      <MotionBg variant="path" dots={2} />
      <div className="container">
        <Reveal className="journey-intro">
          <div className="section-head">
            <p className="eyebrow"><span className="eyebrow-no">04</span>{t.journey.eyebrow}</p>
            <h2>{t.journey.title}</h2>
            <p className="subhead">{t.journey.lead}</p>
          </div>
          <span className="duration-badge" data-testid="duration-badge">{t.journey.duration}</span>
        </Reveal>
        <div className="journey" aria-label="Explore the four-part webinar journey">
          {t.journey.steps.map((item, index) => (
            <Reveal key={item.title} as="button" type="button" className={`journey-step ${active === index ? "active" : ""}`} delay={index * 0.1} aria-pressed={active === index} onClick={() => setActive(index)} data-testid={`journey-step-${index}`}>
              <span className="step-dot">0{index + 1}</span>
              <span className="step-body">
                <span className="step-title">{item.title}</span>
                <span className="step-copy">{item.copy}</span>
              </span>
            </Reveal>
          ))}
        </div>
        <Reveal className="journey-detail" aria-live="polite" data-testid="journey-detail">
          <motion.span key={`no-${active}`} className="journey-detail-no" initial={NO_INITIAL} animate={NO_ANIMATE}>0{active + 1}</motion.span>
          <motion.div key={`copy-${active}`} className="journey-detail-copy" initial={COPY_INITIAL} animate={COPY_ANIMATE} transition={COPY_TRANSITION}>
            <small>{t.journey.takeaway}</small>
            <strong>{step.outcome}</strong>
          </motion.div>
          <motion.p key={`detail-${active}`} initial={DETAIL_INITIAL} animate={DETAIL_ANIMATE}>{step.detail}</motion.p>
        </Reveal>
        {t.journey.outcomes && (
          <Reveal className="outcome-strip" delay={0.1} data-testid="outcome-strip">
            {t.journey.outcomes.map((item) => (
              <div className="outcome-card" key={item.value + item.label}>
                <strong>{item.value}</strong>
                <span>{item.label}</span>
              </div>
            ))}
          </Reveal>
        )}
      </div>
    </InteractiveSection>
  );
}
